/**
 * 接口域名的管理
 * base.js管理接口域名，其他js则用来管理各个模块的接口
 */
// var baseurl='http://localhost:8081/ask';
  var baseurl='/api';
  // console.log("window.location>>>",window.location)
  // console.log("带端口-host>>>",window.location.host)
  // console.log("无端口 -hosetname>>>",window.location.hostname)
// 定义基础路径
const base = {
  bs: baseurl, //多域名的时候可以配多个
  upfileRePath: `${baseurl}/admin/sys/tabFiles/uploadfileRePath`,//返回上传路径-不限类型
  uploadImgRePath: `${baseurl}/admin/sys/tabFiles/uploadImgRePath`,//上传图片返回上传路径
  impPlanUser: `${baseurl}/admin/planUser/impUser`,//导入学员
}
//出口
export default  base;



// WEBPACK FOOTER //
// ./src/request/api/base.js